<template>
    <div class="md-layout-item">
        <h4>Answers</h4>
        <draggable v-model="options_list" group="answers" @end="saveOption">
            <div v-bind:key="index" v-for="(option, index) in options_list">

                <md-divider></md-divider>
                <div class="md-layout md-gutter">
                    <div class="md-layout-item md-size-10">
                            <md-icon>reorder</md-icon>
                    </div>
                    <div class="md-layout-item md-layout md-gutter md-size-65">
                        <div class="md-layout-item md-size-100">
                            <md-field>
                                <label>Tooltip</label>
                                <md-input v-model="option.tooltip"></md-input>
                            </md-field>
                        </div>
                        <div class="md-layout-item">
                            <md-field>
                                <label>Value</label>
                                <md-input v-model="option.value"></md-input>
                            </md-field>
                        </div>
                    </div>

                    <div class="md-layout-item">
                        <md-button @click="removeOption(index)">Remove</md-button>
                    </div>
                </div>
            </div>
        </draggable>
        <md-button class="md-raised md-primary" @click="addOption">Add Option</md-button>
    </div>
</template>

<script>
import draggable from "vuedraggable";

export default {
  name: "FbLikertOption",
  props: ["options"],
  components: {
    draggable,
  },
  data() {
    return {
      options_list: this.options,
    };
  },
  methods: {
    addOption() {
      this.options_list.push({
        checked: false,
        value: "",
      });
    },
    removeOption(index) {
      this.options_list.splice(index, 1);
    },
    saveOption() {
      this.$emit("save-option", this.options_list);
    },
  },
};
</script>
